module.exports = __webpack_public_path__ + "img/brand-strava.5a60ef20.svg";